import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { cartonsActions } from '../actions/cartons.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class CartonsEffects {
    private readonly actions$ = inject(Actions);
    private readonly httpService = inject(HttpService);

    loadCartons$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(cartonsActions.loadCartons),
            switchMap(({ status, page }) => {
                return this.httpService.loadCartons(status, page).pipe(
                    finalizeLoader('cartons-load'),
                    map(({ boxes, hasMore }) => cartonsActions.loadCartonsSuccess({ payload: boxes, page, hasMore })),
                    catchError((error: HttpErrorResponse) => of(cartonsActions.loadCartonsError({ code: error.status }))),
                );
            }),
        );
    });
}
